// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"686":"95be5691","692":"4887f780"}[chunkId] + ".chunk.css";
};